<div class="content p-3 mb-3" *ngFor="let category of attributeGroups">
    <div class="subtitle-2 color-whaleTail ml-2 pb-2 section-header">
        {{category}}
    </div>
    <ng-container *ngFor="let attribute of usersAttributes">
        <ng-container *ngIf="attribute.AttributeFolder == category">
            <div class="row my-2">
                <div class="col-3 ml-2">
                    <div class="color-valyrianSteel">
                        {{attribute.AttributeName}}
                    </div>
                </div>
                <div class="col-3">
                    <div class="color-whaleTail" title="{{attribute.AttributeValueString}}">
                        {{attribute.AttributeValueString.length > 50? attribute.AttributeValueString.slice(0, 50) + "...": attribute.AttributeValueString}}
                    </div>
                </div>
            </div>
        </ng-container>
    </ng-container>
</div>
